import * as types from "../actionTypes";

export const setSubscriptionRevenueByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SUBSCRIPTION_REVENUE_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setSubscriptionRevenueByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SUBSCRIPTION_REVENUE_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceSubscriptionRevenueByYear = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_SUBSCRIPTION_REVENUE_YEARS,
      key,
      payload,
    });
  };
};

export const resetSubscriptionRevenueReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_SUBSCRIPTION_REVENUE_REDUCER,
    });
  };
};
